// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

// Auto-load controllers manually (or with importmap helpers if using importmap)
import HelloController from "./hello_controller.js"
application.register("hello", HelloController)
